"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var GameSetFreeSpinBetTargetsListCtl = /** @class */ (function (_super) {
    __extends(GameSetFreeSpinBetTargetsListCtl, _super);
    function GameSetFreeSpinBetTargetsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_avg_bet_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.avg_bet_amount; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    GameSetFreeSpinBetTargetsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    GameSetFreeSpinBetTargetsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "gameset with id [" + id + "] not found !";
    };
    GameSetFreeSpinBetTargetsListCtl.prototype.LoadData = function (CmsGamesetId, onDone) {
        var _this = this;
        webAApi_1.ListCmsGameSetFreeSpinBetTargetsByCmsGameSetIdGet.exec({
            cms_gameset_id: CmsGamesetId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    avg_bet_amount: resp.list[i].avg_bet_amount,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GameSetFreeSpinBetTargetsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddCmsGameSetFreeSpinBetTarget.exec({
            data: {
                cms_gameset_id: data.cms_gameset_id,
                app_currency_id: data.app_currency_id,
                avg_bet_amount: data.avg_bet_amount
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                app_currency_id: data.app_currency_id,
                app_currency_title: resp.app_currency_title,
                avg_bet_amount: data.avg_bet_amount
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GameSetFreeSpinBetTargetsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditCmsGameSetFreeSpinBetTarget.exec({
                data: {
                    cms_gameset_freespin_bet_id: data.key,
                    avg_bet_amount: data.avg_bet_amount
                }
            }, function (resp) {
                _tmp.avg_bet_amount = data.avg_bet_amount;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GameSetFreeSpinBetTargetsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    GameSetFreeSpinBetTargetsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteCmsGameSetFreeSpinBetTarget.exec({
                data: {
                    cms_gameset_freespin_bet_id: key
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return GameSetFreeSpinBetTargetsListCtl;
}(BaseController_1.BaseController));
exports.GameSetFreeSpinBetTargetsListCtl = GameSetFreeSpinBetTargetsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_gamesets_list/ctl/GameSetFreeSpinBetTargetsListCtl.ts
// module id = 1028
// module chunks = 0